import React from 'react';
import { withMacroStyleWrapper } from '../macroStyleWrapper';
var PlatformHorizontalStackBarChart = /*#__PURE__*/React.lazy(function () {
  return (
    // eslint-disable-next-line import/dynamic-import-chunkname
    import( /* webpackChunkName: '@forge-ui_horizontalstackbarchart' */
    '@atlassian/viz-platform-charts/charts').then(function (module) {
      return {
        default: module.HorizontalStackBarChart
      };
    })
  );
});
var Title = /*#__PURE__*/React.lazy(function () {
  return (
    // eslint-disable-next-line import/dynamic-import-chunkname
    import( /* webpackChunkName: '@forge-ui_horizontalstackbarchart' */
    '@atlassian/viz-platform-charts/charts').then(function (module) {
      return {
        default: module.HorizontalStackBarChart.elements.Title
      };
    })
  );
});
var SubTitle = /*#__PURE__*/React.lazy(function () {
  return (
    // eslint-disable-next-line import/dynamic-import-chunkname
    import( /* webpackChunkName: '@forge-ui_horizontalstackbarchart' */
    '@atlassian/viz-platform-charts/charts').then(function (module) {
      return {
        default: module.HorizontalStackBarChart.elements.SubTitle
      };
    })
  );
});

/**
 * Excluded props:
 * - children - we will not be supporting primitives/elements to compose the chart
 *
 * Limited props:
 * - xAccessor - only allow non function types
 * - yAccessor - only allow non function types
 * - colorAccessor - only allow non function types
 */

var BaseHorizontalStackBarChart = function BaseHorizontalStackBarChart(props) {
  var _ref = props.forgeDoc.props,
    width = _ref.width,
    height = _ref.height,
    data = _ref.data,
    xAccessor = _ref.xAccessor,
    yAccessor = _ref.yAccessor,
    colorAccessor = _ref.colorAccessor,
    title = _ref.title,
    subtitle = _ref.subtitle;
  return /*#__PURE__*/React.createElement(PlatformHorizontalStackBarChart, {
    width: width,
    height: height ? height : 400,
    data: data,
    xAccessor: xAccessor,
    yAccessor: yAccessor,
    colorAccessor: colorAccessor
  }, title && /*#__PURE__*/React.createElement(Title, null, title), subtitle && /*#__PURE__*/React.createElement(SubTitle, null, subtitle));
};
export var HorizontalStackBarChart = withMacroStyleWrapper(BaseHorizontalStackBarChart);